(ns frontend.test.sub
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::selected-test
 (fn [db]
   (get-in db [::selected-test])))

(rf/reg-sub
 ::selected-theme
 (fn [db]
   (get-in db [::selected-theme] )))

(rf/reg-sub
 ::minimize?
 (fn [db]
   (get db ::minimize?)))
